import { Alert, AlertIcon, AlertDescription } from "@chakra-ui/react";

export default function DuplicateEmailInlineAlert({ show }: { show: boolean }) {
  return (
    show && (
      <Alert marginTop={5} status="warning">
        <AlertIcon />
        <AlertDescription>
          We aren&#39;t able to complete your pre-qualification at this time but
          give us a call at <strong>(888) 820-4270</strong> and we will be happy
          to assist you.
        </AlertDescription>
      </Alert>
    )
  );
}
